import { render, staticRenderFns } from "./base-demo-flow.vue?vue&type=template&id=fe60711c&scoped=true&"
import script from "./base-demo-flow.vue?vue&type=script&lang=js&"
export * from "./base-demo-flow.vue?vue&type=script&lang=js&"
import style0 from "./base-demo-flow.vue?vue&type=style&index=0&id=fe60711c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe60711c",
  null
  
)

export default component.exports